import React, { FC } from "react";
import { UserRole } from "@green0meter/api-client";

import {
  Overviews,
  Recommendations,
  ServicesMarketplaceHome,
  HomeWelcomeBanner,
  EsgAcademyFeed,
} from "@components/main/home";
import { Box, Grid } from "@components/base";
import { DemoDataAlert } from "@components/common";
import { useUserStore } from "@store/user";

const UserHomePage: FC = () => {
  const { user } = useUserStore();

  const isNotViewer = user?.role !== UserRole.Viewer && user?.role !== UserRole.Auditor;
  const isNotRespondent = user?.role !== UserRole.Respondent;

  return (
    <Box mb={6}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <HomeWelcomeBanner />
        </Grid>
        {isNotViewer && isNotRespondent &&<Grid size={12}>
           <Recommendations />
        </Grid>}
        {isNotViewer && isNotRespondent && <Grid size={12}>
          <ServicesMarketplaceHome />
        </Grid>}
        {isNotRespondent && isNotViewer && <DemoDataAlert />}
        {isNotRespondent &&<Grid size={12}> <Overviews /></Grid>}
        {user && (
          <Grid size={12}>
            <EsgAcademyFeed locale={user.localizationLanguage} />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default UserHomePage;
